import { render, staticRenderFns } from "./ContractDealer.vue?vue&type=template&id=3cddbba2&scoped=true"
import script from "./ContractDealer.vue?vue&type=script&lang=js"
export * from "./ContractDealer.vue?vue&type=script&lang=js"
import style0 from "./ContractDealer.vue?vue&type=style&index=0&id=3cddbba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cddbba2",
  null
  
)

export default component.exports